import { Component, Inject } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { EventBusService } from '../../services/event-bus.service';

@Component({
  selector: 'rm-locations-dialog',
  templateUrl: './locations-dialog.component.html',
  styleUrls: ['./locations-dialog.component.css']
})
export class LocationsDialogComponent implements OnInit {
  
  productId: string;
  gcp: string;
  gln: string;

  subscriptions: any[] = [];
  locations: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ebService: EventBusService
  ) {}

  ngOnInit() {
    this.productId = this.data.productId;
    this.gcp = this.data.gcp;
    this.gln = this.data.gln;
  }
}